import {
  Box,
  Button,
  Checkbox,
  Fade,
  MenuItem,
  Paper,
  Popper,
  PopperPlacementType,
  Select,
  TextField,
  IconButton,
} from "@mui/material";
import DangerousRoundedIcon from '@mui/icons-material/DangerousRounded';
// import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import api from "../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { SearchBackDrop } from "../component/common/SearchBackDrop";
import CustomPagination from "../component/common/CustomPagination";
import SsbJsonDialog from "./SsbJsonDialog";
// import EvalTextViewPage_204 from "../EvalTextViewPage_204";


const initailEvknData: any = {
  idx : -1,

  task: "simpleqa",
  data_sources: "",
  category: "",
  subcategory: "",
  bmk_pk: "",
  difficulty: "",
  keyword: "",
  title: "",
  text: "",
  
  qa_type: "",
  answer_type: "",
  science_fact: "",
  common_knowledge: "",
  
  activity: "",
  question_a: "",
  question_b: "",
  question: "",

  answer: "",
  answer_index: "",

  option_1: "",
  option_2: "",
  option_3: "",
  option_4: "",
  option_5: "",

  reason_1: "",
  reason_2: "",
  reason_3: "",
  reason_4: "",
  reason_5: "",

  job_user:"",
  job_date:"",
  des:"",
};

const ispChecklistDef = [
  { key:'i1',   label:'1. 도메인분류정확성', isParent:false, indent:false, height:100 },
  { key:'i2',   label:'2. 질문적정성',       isParent:true,  indent:false, height:0  },
  { key:'i2_1', label:'2-1. 문법표현',       isParent:false, indent:true,  height:40 },
  { key:'i2_2', label:'2-2. RedBenign라벨',  isParent:false, indent:true,  height:60 },
  { key:'i2_3', label:'2-3. 트랙형식',       isParent:false, indent:true,  height:60 },
  { key:'i2_4', label:'2-4. 트랙내용',       isParent:false, indent:true,  height:60 },
];

const ISP_KEYS = ['i1','i2_1','i2_2','i2_3','i2_4'];

const initIspChecklist: {[key:string]:string} = {
  i1:'PASS', i2_1:'PASS', i2_2:'PASS', i2_3:'PASS', i2_4:'PASS',
};

const initIspReasons: {[key:string]:string} = {
  i1:'', i2_1:'', i2_2:'', i2_3:'', i2_4:'',
};


export interface pageInfoType {
  current_page: number;
  total_pages: number;
}

const IspWorkerPage = (props: any) => {

  const [openJsonDialog, setOpenJsonDialog] = useState<boolean>(false)

  const [ssb_detail_data, setEvkn_detail_data] = useState<any>(initailEvknData);

  const [page, setPage] = useState(1);
  const [c_page, setC_page] = useState("")
  const [order, setOrder] = useState('desc');
  const [total_cnt, setTotal_cnt] = useState(0);
  
  const [pagination, setPagination] = useState<pageInfoType | undefined>(undefined);

  const [ssbWorkList, setSsbWorkList] = useState([]);

  const [isp_yn, setIsp_yn] = useState('모두');
  const [job_yn_filter, setJob_yn_filter] = useState('모두');
  const [track_filter, setTrack_filter] = useState('모두');
  const [summaryInfo, setSummaryInfo] = useState({total: 0, y_count: 0, n_count: 0});

  const [backdrop, setBackdrop] = useState<boolean>(false)

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  const [ssbData, setSsbData] = useState<any>([]);

  const [options, setOptions] = useState<any>([]);

  const [groundTruth, setGroundTruth] = useState<any>(null);
  const [metaOpen, setMetaOpen] = useState(false);

  const [ispChecklist, setIspChecklist] = useState<{[key:string]:string}>(initIspChecklist);
  const [ispReasons, setIspReasons] = useState<{[key:string]:string}>(initIspReasons);

  const hasIspFailItem = ISP_KEYS.some(k => ispChecklist[k] === 'FAIL');

  useEffect(() => {
    try {
      const parsed = typeof ssbData.prc_json === 'string' ? JSON.parse(ssbData.prc_json) : ssbData.prc_json;
      setGroundTruth(parsed?.ground_truth ?? null);
    } catch {
      setGroundTruth(null);
    }
  }, [ssbData.prc_json]);

  useEffect(() => {
    const toResult = (val: string) => val === 'FAIL' ? 'FAIL' : 'PASS';
    setIspChecklist({
      i1:   toResult(ssbData.domain_classification_result  || ''),
      i2_1: toResult(ssbData.grammar_expression_result     || ''),
      i2_2: toResult(ssbData.red_benign_label_result       || ''),
      i2_3: toResult(ssbData.track_format_result           || ''),
      i2_4: toResult(ssbData.track_content_result          || ''),
    });
    setIspReasons({
      i1:   ssbData.domain_classification_reason  || '',
      i2_1: ssbData.grammar_expression_reason     || '',
      i2_2: ssbData.red_benign_label_reason       || '',
      i2_3: ssbData.track_format_reason           || '',
      i2_4: ssbData.track_content_reason          || '',
    });
  }, [ssbData.idx]);

  const options_change = (idx: number, val: string) => {
    setOptions((prev:any) => {
      const next = [...prev];
      next[idx] = { ...next[idx], choice_text: val };
      return next;
    });
  };

  const rationale_change = (idx: number, val: string) => {
    setGroundTruth((prev:any) => {
      if (!prev?.choice_rationales) return prev;
      const rationales = [...prev.choice_rationales];
      rationales[idx] = { ...rationales[idx], rationale: val };
      return { ...prev, choice_rationales: rationales };
    });
  };

  const handleSave = (job_yn: string) => {
    if (!ssbData.idx) return;
    setBackdrop(true);

    const prc_checklist = ISP_KEYS.map(k => ispChecklist[k] === 'FAIL' ? 'F' : 'T').join('');

    let updatedPrcJson = ssbData.prc_json;
    try {
      const parsed = typeof ssbData.prc_json === 'string' ? JSON.parse(ssbData.prc_json) : ssbData.prc_json;
      updatedPrcJson = JSON.stringify({ ...parsed, ground_truth: groundTruth });
    } catch {}

    api.post('/updateSsbIspData', {
      ...ssbData,
      email,
      options: JSON.stringify(options),
      prc_json: updatedPrcJson,
      job_yn,
      prc_checklist,
      domain_classification_result:    ispChecklist.i1,
      domain_classification_reason:    ispReasons.i1,
      grammar_expression_result:       ispChecklist.i2_1,
      grammar_expression_reason:       ispReasons.i2_1,
      red_benign_label_result:         ispChecklist.i2_2,
      red_benign_label_reason:         ispReasons.i2_2,
      track_format_result:             ispChecklist.i2_3,
      track_format_reason:             ispReasons.i2_3,
      track_content_result:            ispChecklist.i2_4,
      track_content_reason:            ispReasons.i2_4,
    })
    .then(() => {
      setBackdrop(false);
      alert(`${ssbData.bmk_id} ${job_yn === 'Y' ? '수정하였습니다' : '부적합 처리하였습니다'}`);
      getSummary();
      getSsbDataList();
    })
    .catch((error:any) => {
      console.error('저장 오류', error?.response);
      setBackdrop(false);
    });
  };

  const goPage = (clickPage: any) => {
    setPage(clickPage);
  };

  const getSummary = () => {
    api.get('/ssbIspSummary', {params: {worker}})
      .then((res: any) => setSummaryInfo(res.data))
      .catch(() => {});
  };

  const getSsbDataList = async (selectFirst: boolean = false) => {

    setBackdrop(true)
    api.get('/ssbIspDataList',{params:{email:email, worker:worker, page:page, order:order, isp_yn:isp_yn, job_yn:job_yn_filter, track:track_filter, idx:""}})
    .then((res:any) => {
      
      if(res.data.datas.length > 0){
        setSsbWorkList(res.data.datas);
        
        if (selectFirst) {
          // 호출 시 명시적으로 첫 번째 row 선택
          setSsbData(res.data.datas[0]);
        }else if((ssbData && ssbData.idx == -1) || (pagination && page != pagination.current_page)){
          setSsbData(res.data.datas[0])
        }
        setPagination(res.data.pagination)
        setTotal_cnt(res.data.pagination.total_count)
      }else{
        setSsbWorkList(res.data.datas);
        setPagination(res.data.pagination)
        setTotal_cnt(0)
      }
      setBackdrop(false)
      })
    .catch((error:any) => {console.error('에러',error.response);setBackdrop(false);})
  }

  useEffect(() => {
    getSummary();
  }, []);

  useEffect(() => {
    getSsbDataList()
  }, [page, props.rowDetail, job_yn_filter, track_filter]);
  
  return (
    <Paper sx={{width:"100%", overflow: "auto"}}>
      {backdrop && ( <SearchBackDrop message={"처리중..."}/> )}
      <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>사회적 안전성(검수)</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box display="flex">

        {/* <EvalTextViewPage sid={ssbData.source_id} /> */}
        {/* <EvalTextViewPage_204 sid={ssbData.source_id} /> */}

        {/* 사회적 안전성 데이터 */}
        <Box display="flex">
          <Box sx={{width:"100%"}}>
            <Paper sx={{padding:"2px", border:"3px solid #3e36a5", backgroundColor:"#e8f4ff"}}>
              <Box sx={{margin:"2px"}}>

                {/* 제목 + JSON 버튼 */}
                <Box sx={{display:"flex", justifyContent:"center", alignItems:"center", marginBottom:"8px"}}>
                  <Box sx={{fontSize:"18px", fontWeight:700, textAlign:"center", margin:"2px"}}>{ssbData.track} - {ssbData.bmk_id}</Box>
                  <Button variant="contained" size="small" sx={{marginLeft:"32px", fontWeight:700, backgroundColor:"#e79055"}} onClick={() => setOpenJsonDialog(true)}>
                    OPEN JSON
                  </Button>
                </Box>
                {openJsonDialog ? <SsbJsonDialog className="json-dialog-content" data={ssbData.submission_json} setOpenJsonDialog={setOpenJsonDialog} />:<></>}

                {/* 메타데이터 그리드 */}
                <Box sx={{border:"1.5px solid #9090c8", borderRadius:"8px", overflow:"hidden"}}>

                  {/* 토글 헤더 */}
                  <Box
                    onClick={() => setMetaOpen(prev => !prev)}
                    sx={{
                      display:"flex", alignItems:"flex-start", gap:"6px",
                      padding:"5px 12px", cursor:"pointer",
                      backgroundColor: metaOpen ? "#6c66c0" : "#3e36a5",
                      userSelect:"none",
                      "&:hover": {backgroundColor:"#3e36a5"},
                    }}
                  >
                    <Box sx={{color:"#fff", fontSize:"12px", fontWeight:700, letterSpacing:"0.8px", flexShrink:0, paddingTop:"2px"}}>METADATA</Box>
                    <Box sx={{display:"flex", flexDirection:"column", gap:"3px", marginLeft:"10px", flex:1}}>
                      <Box sx={{display:"flex", gap:"4px", flexWrap:"wrap"}}>
                        {([
                          {label:"TRACK",    value: ssbData.track,      bg:"#000"},
                          {label:"BMK_ID",   value: ssbData.bmk_id,     bg:"#000"},
                          {label:"SOURCE_ID",value: ssbData.source_id,  bg:"#000"},
                        ] as {label:string; value:any; bg:string}[]).map(item => (
                          <Box key={item.label} sx={{display:"flex", alignItems:"center", border:"1px solid #9090c8", borderRadius:"4px", overflow:"hidden", boxShadow:"0 1px 2px rgba(0,0,0,0.08)", flexShrink:0}}>
                            <Box sx={{backgroundColor:item.bg, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px", letterSpacing:"0.3px"}}>{item.label}</Box>
                            <Box sx={{backgroundColor:"#fff", fontSize:"12px", padding:"2px 8px", minWidth:"30px", maxWidth:"200px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontFamily:"Noto Sans KR"}}>{String(item.value ?? "")}</Box>
                          </Box>
                        ))}
                        {(() => {
                          try {
                            const sub = typeof ssbData.submission_json === 'string' ? JSON.parse(ssbData.submission_json) : ssbData.submission_json;
                            const or = sub?.over_refusal?.[0] ?? sub?.over_refusal;
                            if (!or) return null;
                            const isRed = String(or.over_refusal_type ?? '').toLowerCase() === 'red';
                            const baseColor = isRed ? '#c0392b' : '#2563b0';
                            const baseBorder = isRed ? '#e08080' : '#8090d0';
                            const baseBg    = isRed ? '#fff8f8' : '#f4f7ff';
                            const benignVal = String(or.benign_state ?? '').toLowerCase();
                            const benignIsNone = benignVal === '' || benignVal === 'none' || benignVal === 'null';
                            const benignColor  = benignIsNone ? baseColor  : '#27a348';
                            const benignBorder = benignIsNone ? baseBorder : '#80c8a0';
                            const benignBg     = benignIsNone ? baseBg     : '#f4fff8';
                            return (
                              <>
                                <Box sx={{display:"flex", alignItems:"center", border:`1px solid ${baseBorder}`, borderRadius:"4px", overflow:"hidden", boxShadow:"0 1px 2px rgba(0,0,0,0.08)", flexShrink:0}}>
                                  <Box sx={{backgroundColor:baseColor, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px", letterSpacing:"0.3px"}}>OVER_REFUSAL_TYPE</Box>
                                  <Box sx={{backgroundColor:baseBg, fontSize:"12px", padding:"2px 8px", minWidth:"30px", maxWidth:"200px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontFamily:"Noto Sans KR", color:baseColor, fontWeight:700}}>{String(or.over_refusal_type ?? "")}</Box>
                                </Box>
                                <Box sx={{display:"flex", alignItems:"center", border:`1px solid ${benignBorder}`, borderRadius:"4px", overflow:"hidden", boxShadow:"0 1px 2px rgba(0,0,0,0.08)", flexShrink:0}}>
                                  <Box sx={{backgroundColor:benignColor, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px", letterSpacing:"0.3px"}}>BENIGN_STATE</Box>
                                  <Box sx={{backgroundColor:benignBg, fontSize:"12px", padding:"2px 8px", minWidth:"30px", maxWidth:"200px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontFamily:"Noto Sans KR", color:benignColor, fontWeight:700}}>{String(or.benign_state ?? "")}</Box>
                                </Box>
                              </>
                            );
                          } catch { return null; }
                        })()}
                      </Box>
                      <Box sx={{display:"flex", gap:"4px"}}>
                        {([
                          {label:"도메인코드", value: ssbData.domain_cd,  bg:"#2d7a4f"},
                          {label:"도메인",    value: ssbData.domain,      bg:"#2d7a4f"},
                          {label:"서브도메인", value: ssbData.subdomain,  bg:"#2d7a4f"},
                          {label:"DIFFICULTY",value: ssbData.difficulty,  bg:"#7a4f2d"},
                        ] as {label:string; value:any; bg:string}[]).map(item => (
                          <Box key={item.label} sx={{display:"flex", alignItems:"center", border:"1px solid #9090c8", borderRadius:"4px", overflow:"hidden", boxShadow:"0 1px 2px rgba(0,0,0,0.08)", flexShrink:0}}>
                            <Box sx={{backgroundColor:item.bg, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px", letterSpacing:"0.3px"}}>{item.label}</Box>
                            <Box sx={{backgroundColor:"#fff", fontSize:"12px", padding:"2px 8px", minWidth:"30px", maxWidth:"300px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontFamily:"Noto Sans KR"}}>{String(item.value ?? "")}</Box>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                    <Box sx={{color:"#ccd", fontSize:"11px", marginLeft:"auto", flexShrink:0, paddingTop:"2px"}}>{metaOpen ? "▲" : "▼"}</Box>
                  </Box>

                  {/* 접히는 콘텐츠 */}
                  {metaOpen && (
                    <Box sx={{backgroundColor:"#f4f4ff", padding:"10px", display:"flex", flexDirection:"column", gap:"6px"}}>

                      {/* 식별자 */}
                      <Box sx={{display:"flex", flexWrap:"wrap", gap:"6px"}}>
                        {([
                          {label:"IDX",       value: ssbData.idx,       bg:"#3e36a5"},
                          {label:"TRACK",     value: ssbData.track,     bg:"#3e36a5"},
                          {label:"BMK_ID",    value: ssbData.bmk_id,    bg:"#3e36a5"},
                          {label:"SOURCE_ID", value: ssbData.source_id, bg:"#3e36a5"},
                        ] as {label:string; value:any; bg:string}[]).map((item) => (
                          <Box key={item.label} sx={{display:"flex", alignItems:"center", border:"1px solid #9090c8", borderRadius:"4px", overflow:"hidden", boxShadow:"0 1px 2px rgba(0,0,0,0.08)"}}>
                            <Box sx={{backgroundColor:item.bg, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px", letterSpacing:"0.3px"}}>{item.label}</Box>
                            <Box sx={{backgroundColor:"#fff", fontSize:"12px", padding:"2px 8px", minWidth:"30px", fontFamily:"Noto Sans KR"}}>{String(item.value ?? "")}</Box>
                          </Box>
                        ))}
                      </Box>

                      {/* 도메인 */}
                      <Box sx={{display:"flex", flexWrap:"wrap", gap:"6px"}}>
                        {([
                          {label:"도메인코드", value: ssbData.domain_cd, bg:"#2d7a4f"},
                          {label:"도메인",     value: ssbData.domain,    bg:"#2d7a4f"},
                          {label:"서브도메인", value: ssbData.subdomain, bg:"#2d7a4f"},
                        ] as {label:string; value:any; bg:string}[]).map((item) => (
                          <Box key={item.label} sx={{display:"flex", alignItems:"center", border:"1px solid #9090c8", borderRadius:"4px", overflow:"hidden", boxShadow:"0 1px 2px rgba(0,0,0,0.08)"}}>
                            <Box sx={{backgroundColor:item.bg, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px", letterSpacing:"0.3px"}}>{item.label}</Box>
                            <Box sx={{backgroundColor:"#fff", fontSize:"12px", padding:"2px 8px", minWidth:"30px", maxWidth:"400px", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", fontFamily:"Noto Sans KR"}}>{String(item.value ?? "")}</Box>
                          </Box>
                        ))}
                      </Box>

                      {/* 유형 / 특성 */}
                      <Box sx={{display:"flex", flexWrap:"wrap", gap:"6px"}}>
                        {([
                          {label:"ITEM_TYPE",     value: ssbData.item_type,     bg:"#7a4f2d"},
                          {label:"DIFFICULTY",    value: ssbData.difficulty,    bg:"#7a4f2d"},
                          {label:"WORD_COUNT",    value: ssbData.word_count,    bg:"#7a4f2d"},
                          {label:"DIALOGUE_TYPE", value: ssbData.dialogue_type, bg:"#7a4f2d"},
                          {label:"TURN_COUNT",    value: ssbData.turn_count,    bg:"#7a4f2d"},
                          {label:"ROLEPLAY_TYPE", value: ssbData.roleplay_type, bg:"#7a4f2d"},
                        ] as {label:string; value:any; bg:string}[]).map((item) => (
                          <Box key={item.label} sx={{display:"flex", alignItems:"center", border:"1px solid #9090c8", borderRadius:"4px", overflow:"hidden", boxShadow:"0 1px 2px rgba(0,0,0,0.08)"}}>
                            <Box sx={{backgroundColor:item.bg, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px", letterSpacing:"0.3px"}}>{item.label}</Box>
                            <Box sx={{backgroundColor:"#fff", fontSize:"12px", padding:"2px 8px", minWidth:"30px", fontFamily:"Noto Sans KR"}}>{String(item.value ?? "")}</Box>
                          </Box>
                        ))}
                      </Box>

                      {/* 정답 관련 */}
                      <Box sx={{display:"flex", flexWrap:"wrap", gap:"6px"}}>
                        {([
                          {label:"GT_LABEL",      value: ssbData.gt_label,           highlight: false},
                          {label:"ANS_INDEX",     value: ssbData.answer_index,       highlight: false},
                          {label:"ANS_CHOICE",    value: ssbData.answer_choice_id,   highlight: true},
                          {label:"TARGET_TURN",   value: ssbData.target_turn,        highlight: false},
                          {label:"ANS_TGT_TURN",  value: ssbData.answer_target_turn, highlight: false},
                        ] as {label:string; value:any; highlight:boolean}[]).map((item) => (
                          <Box key={item.label} sx={{display:"flex", alignItems:"center", border: item.highlight ? "1.5px solid #d44" : "1px solid #9090c8", borderRadius:"4px", overflow:"hidden", boxShadow:"0 1px 2px rgba(0,0,0,0.08)"}}>
                            <Box sx={{backgroundColor:"#4664b4", color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px", letterSpacing:"0.3px"}}>{item.label}</Box>
                            <Box sx={{backgroundColor: item.highlight ? "#f0ffea" : "#fff", fontSize:"12px", fontWeight: item.highlight ? 700 : 400, color: item.highlight ? "#c00" : "#000", padding:"2px 8px", minWidth:"30px", fontFamily:"Noto Sans KR"}}>{String(item.value ?? "")}</Box>
                          </Box>
                        ))}
                      </Box>

                      {/* over_refusal */}
                      {(() => {
                        try {
                          const sub = typeof ssbData.submission_json === 'string' ? JSON.parse(ssbData.submission_json) : ssbData.submission_json;
                          const or = sub?.over_refusal?.[0] ?? sub?.over_refusal;
                          if (!or) return null;
                          const isRed = String(or.over_refusal_type ?? '').toLowerCase() === 'red';
                          const baseColor = isRed ? '#c0392b' : '#2563b0';
                          const baseBorder = isRed ? '#e08080' : '#8090d0';
                          const baseBg    = isRed ? '#fff8f8' : '#f4f7ff';
                          const benignVal = String(or.benign_state ?? '').toLowerCase();
                          const benignIsNone = benignVal === '' || benignVal === 'none' || benignVal === 'null';
                          const benignColor  = benignIsNone ? baseColor  : '#27a348';
                          const benignBorder = benignIsNone ? baseBorder : '#80c8a0';
                          const benignBg     = benignIsNone ? baseBg     : '#f4fff8';
                          return (
                            <Box sx={{display:"flex", flexWrap:"wrap", gap:"6px"}}>
                              <Box sx={{display:"flex", alignItems:"center", border:`1px solid ${baseBorder}`, borderRadius:"4px", overflow:"hidden", boxShadow:"0 1px 2px rgba(0,0,0,0.08)"}}>
                                <Box sx={{backgroundColor:baseColor, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px", letterSpacing:"0.3px"}}>OVER_REFUSAL_TYPE</Box>
                                <Box sx={{backgroundColor:baseBg, fontSize:"12px", padding:"2px 8px", minWidth:"30px", fontFamily:"Noto Sans KR", color:baseColor, fontWeight:700}}>{String(or.over_refusal_type ?? "")}</Box>
                              </Box>
                              <Box sx={{display:"flex", alignItems:"center", border:`1px solid ${benignBorder}`, borderRadius:"4px", overflow:"hidden", boxShadow:"0 1px 2px rgba(0,0,0,0.08)"}}>
                                <Box sx={{backgroundColor:benignColor, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px", letterSpacing:"0.3px"}}>BENIGN_STATE</Box>
                                <Box sx={{backgroundColor:benignBg, fontSize:"12px", padding:"2px 8px", minWidth:"30px", fontFamily:"Noto Sans KR", color:benignColor, fontWeight:700}}>{String(or.benign_state ?? "")}</Box>
                              </Box>
                            </Box>
                          );
                        } catch { return null; }
                      })()}

                      {/* 점수 / 제출 / 상태 */}
                      <Box sx={{display:"flex", flexWrap:"wrap", gap:"6px"}}>
                        {([
                          {label:"SCORE_GPT",  value: ssbData.scoregpt,   bg:"#6d2d7a"},
                          {label:"SCORE_GEM",  value: ssbData.scoregem,   bg:"#6d2d7a"},
                          {label:"NIA_SUBMIT", value: ssbData.nia_submit,  bg:"#6d2d7a"},
                          {label:"ISP_YN",     value: ssbData.isp_yn,     bg:"#6d2d7a"},
                          {label:"WORKER",     value: ssbData.worker,     bg:"#6d2d7a"},
                          {label:"JOB_YN",     value: ssbData.job_yn,     bg:"#6d2d7a"},
                          {label:"INS_DATE",   value: ssbData.ins_date,   bg:"#6d2d7a"},
                          {label:"JOB_DATE",   value: ssbData.job_date,   bg:"#6d2d7a"},
                        ] as {label:string; value:any; bg:string}[]).map((item) => (
                          <Box key={item.label} sx={{display:"flex", alignItems:"center", border:"1px solid #9090c8", borderRadius:"4px", overflow:"hidden", boxShadow:"0 1px 2px rgba(0,0,0,0.08)"}}>
                            <Box sx={{backgroundColor:item.bg, color:"#fff", fontSize:"10px", fontWeight:700, padding:"2px 6px", letterSpacing:"0.3px"}}>{item.label}</Box>
                            <Box sx={{backgroundColor:"#fff", fontSize:"12px", padding:"2px 8px", minWidth:"30px", fontFamily:"Noto Sans KR"}}>{String(item.value ?? "")}</Box>
                          </Box>
                        ))}
                      </Box>

                    </Box>
                  )}
                </Box>

              </Box>

                  <Box>
                    <Box>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"100%"}}>
                          <Box sx={{margin:"0px 0px 0px 2px", color:"#3e36a5", fontWeight:700}}>System-prompt</Box>
                          <Box><textarea spellCheck="false" value={ssbData.pt_system || ""} onChange={(e) => {setSsbData({ ...ssbData, pt_system: e.target.value });}} style={{border:"4px solid #000", width:"100%", minHeight:"32px", height:"32px", fontSize:"14px", padding:"2px", fontFamily: "Noto Sans KR", boxSizing:"border-box"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"100%"}}>
                          <Box sx={{margin:"0px 0px 0px 2px", color:"#3e36a5", fontWeight:700}}>Content (난이도 : <b style={{fontSize:"13px", fontWeight:700, textAlign:"center", margin:"2px", color:(ssbData.difficulty === "high" ? "red":(ssbData.difficulty === "medium" ? "#d76800": "#00db45")) }}>{(ssbData.difficulty === "high" ? "High":(ssbData.difficulty === "medium" ? "Medium": "Low"))}</b>)</Box>
                          <Box><textarea spellCheck="false" value={ssbData.content || ""} onChange={(e) => {setSsbData({ ...ssbData, content: e.target.value });}} style={{border:"4px solid #000", width:"100%", minHeight:"28px", fontSize:"14px", padding:"2px", fontFamily:"Noto Sans KR", boxSizing:"border-box"}} /></Box>
                        </Box>
                      </Box>
                    </Box>
                    <Box>
                      <Box sx={{display:"flex", alignItems:"center"}}>
                        <Box sx={{width:"100%"}}>
                          <Box sx={{margin:"0px 0px 0px 2px", color:"#3e36a5", fontWeight:700}}>Question_text</Box>
                          <Box><textarea spellCheck="false" value={ssbData.question || ""} onChange={(e) => {setSsbData({ ...ssbData, question: e.target.value });}} style={{border:"4px solid #000", width:"100%",minHeight:"52px", fontSize:"14px",padding:"2px", fontFamily: "Noto Sans KR", boxSizing:"border-box"}}  /></Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  <Box>

                    <Box>
                      <Box sx={{margin:"0px 0px 2px 2px", color:"#3e36a5", fontWeight:700}}>Options (choice_text / rationale)</Box>
                      <Box sx={{display:"flex", flexDirection:"column", gap:"6px"}}>
                        {options && options.map((item:any, index:any) => {
                          const isCorrect = ssbData.answer_choice_id === String.fromCharCode(65 + index);
                          const rationale = groundTruth?.choice_rationales?.[index];
                          const isCorrectRationale = rationale?.answer_type === "정답";
                          return (
                            <Box key={"Box_Options"+index} sx={{
                              display:"flex",
                              alignItems:"stretch",
                              borderRadius:"6px",
                              border: isCorrect ? "2px solid #27a348" : "1.5px solid #c8c8d8",
                              borderLeft: isCorrect ? "6px solid #27a348" : "6px solid #9090b8",
                              backgroundColor: isCorrect ? "#f0fff4" : "#fafafa",
                              boxShadow: isCorrect ? "0 2px 8px rgba(39,163,72,0.12)" : "0 1px 3px rgba(0,0,0,0.05)",
                              overflow:"hidden",
                            }}>
                              {/* 알파벳 배지 */}
                              <Box sx={{
                                display:"flex", alignItems:"center", justifyContent:"center",
                                width:"30px", minWidth:"30px", flexShrink:0,
                                backgroundColor: isCorrect ? "#27a348" : "#8888aa",
                                color:"#fff", fontWeight:900, fontSize:"17px",
                              }}>
                                {String.fromCharCode(65 + index)}
                              </Box>

                              {/* choice_text */}
                              <Box sx={{flex:"1", padding:"2px 10px", display:"flex", alignItems:"center", minWidth:0}}>
                                <textarea
                                  readOnly={(isCorrect && worker !== "EVAL007")}
                                  spellCheck="false"
                                  value={item.choice_text || ""}
                                  onChange={(!isCorrect || worker === "EVAL007") ? (e:any) => options_change(index, e.target.value) : undefined}
                                  style={{
                                    width:"652px", minHeight:"112px", fontSize:"14px", fontWeight:500,
                                    padding:"0px", resize:"vertical", outline:"none",
                                    backgroundColor:"transparent", border:"none",
                                    fontFamily:"Noto Sans KR", lineHeight:"1.6",
                                  }}
                                />
                              </Box>

                              {/* 구분선 */}
                              {rationale !== undefined && (
                                <Box sx={{width:"1px", flexShrink:0, backgroundColor: isCorrect ? "#b0dfc0" : "#d0d0e0", margin:"6px 0"}} />
                              )}

                              {/* rationale */}
                              {rationale !== undefined && (
                                <Box sx={{padding:"4px 10px", display:"flex", flexDirection:"column", gap:"1px", width:"460px", minWidth:"460px"}}>
                                  <Box sx={{
                                    alignSelf:"flex-start",
                                    display:"inline-flex", alignItems:"center",
                                    backgroundColor: isCorrectRationale ? "#d4f5de" : "#fce8d0",
                                    color: isCorrectRationale ? "#1a7a35" : "#8a4a00",
                                    fontSize:"10px", fontWeight:700, padding:"1px 8px",
                                    borderRadius:"8px",
                                    border: isCorrectRationale ? "1px solid #27a348" : "1px solid #e08030",
                                  }}>
                                    {rationale?.answer_type || ""}
                                  </Box>
                                  <textarea
                                    spellCheck="false"
                                    value={rationale?.rationale || ""}
                                    onChange={(e) => rationale_change(index, e.target.value)}
                                    style={{
                                      width:"448px", minHeight:"84px", fontSize:"13px",
                                      padding:"0px 0px", fontFamily:"Noto Sans KR",
                                      backgroundColor:"transparent", border:"none",
                                      resize:"none", outline:"none", color:"#333", lineHeight:"1.6",
                                    }}
                                  />
                                </Box>
                              )}
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  </Box>


            </Paper>
          </Box>
        </Box>
        {/* 사회적 안전성 데이터 */}

        {/* 체크리스트 */}
        <Box sx={{
          marginLeft:"2px", alignSelf:"flex-start", position:"sticky", top:0,
          marginTop:"12px", display:"flex", flexDirection:"column",
        }}>

          {/* 요약 스탯 카드 */}
          <Box sx={{display:"flex", gap:"6px", marginBottom:"8px", width:"470px"}}>
            {([
              {label:"총",    value: summaryInfo.total,                                            color:"#3e36a5", bg:"#f0f0ff", border:"#9090c8"},
              {label:"적합",  value: summaryInfo.y_count,                                          color:"#27a348", bg:"#f0fff4", border:"#a8ddb5"},
              {label:"부적합",value: summaryInfo.n_count,                                          color:"#c0392b", bg:"#fff0ee", border:"#f0b0a8"},
              {label:"미작업",value: summaryInfo.total - summaryInfo.y_count - summaryInfo.n_count, color:"#888",    bg:"#f5f5f5", border:"#ccc"},
            ] as {label:string; value:number; color:string; bg:string; border:string}[]).map(item => (
              <Box key={item.label} sx={{
                flex:1, padding:"5px 10px",
                border:`1.5px solid ${item.border}`, borderRadius:"8px",
                backgroundColor: item.bg,
                display:"flex", alignItems:"center", gap:"8px",
              }}>
                <Box sx={{fontSize:"11px", fontWeight:600, color:"#999"}}>{item.label}</Box>
                <Box sx={{display:"flex", alignItems:"baseline", gap:"2px"}}>
                  <Box sx={{fontSize:"20px", fontWeight:800, color:item.color, lineHeight:1}}>{item.value}</Box>
                  <Box sx={{fontSize:"11px", fontWeight:600, color:item.color}}>건</Box>
                </Box>
              </Box>
            ))}
          </Box>

          <Box sx={{
            width:"470px", minWidth:"470px",
            border:"1.5px solid #c8c8e8", borderRadius:"10px", overflow:"hidden",
            boxShadow:"0 2px 12px rgba(62,54,165,0.10)",
          }}>
            {/* 헤더 */}
            <Box sx={{
              padding:"9px 14px",
              background:"linear-gradient(90deg, #2d8c50 0%, #3ba35c 100%)",
              display:"flex", alignItems:"center",
            }}>
              <Box sx={{color:"#fff", fontSize:"12px", fontWeight:700, letterSpacing:"0.8px"}}>검수 체크리스트</Box>
              {hasIspFailItem && (
                <Box sx={{
                  marginLeft:"auto", fontSize:"10px", fontWeight:700,
                  color:"#ffcccc", backgroundColor:"rgba(255,255,255,0.18)",
                  padding:"2px 9px", borderRadius:"10px", letterSpacing:"0.3px",
                }}>FAIL 항목 있음</Box>
              )}
            </Box>

            <Box sx={{backgroundColor:"#fff", overflowY:"auto"}}>
              {ispChecklistDef.map((item, i) => {
                if (item.isParent) {
                  return (
                    <Box key={item.key} sx={{
                      padding:"7px 12px",
                      borderBottom:"1px solid #ebebf5",
                      borderLeft:"3px solid #3e36a5",
                      backgroundColor:"#f4f4fb",
                    }}>
                      <Box sx={{fontSize:"11px", fontWeight:800, color:"#3e36a5", letterSpacing:"0.4px"}}>{item.label}</Box>
                    </Box>
                  );
                }
                const isFail = ispChecklist[item.key] === 'FAIL';
                return (
                  <Box key={item.key} sx={{
                    borderBottom: i < ispChecklistDef.length - 1 ? "1px solid #ebebf5" : "none",
                    padding: item.indent ? "8px 10px 8px 22px" : "8px 10px",
                    backgroundColor: isFail ? "#fff4f4" : "#fff",
                    borderLeft: item.indent ? "3px solid #e0e0f0" : "none",
                  }}>
                    {/* 라벨 + PASS/FAIL 토글 */}
                    <Box sx={{display:"flex", justifyContent:"space-between", alignItems:"center", gap:"6px", marginBottom:"6px"}}>
                      <Box sx={{fontSize:"11px", fontWeight:700, color: isFail ? "#c0392b" : "#444", flex:1}}>{item.label}</Box>
                      <Box sx={{display:"flex", gap:"4px", flexShrink:0}}>
                        {(['PASS','FAIL'] as const).map(val => {
                          const isSelected = ispChecklist[item.key] === val;
                          const isPass = val === 'PASS';
                          return (
                            <Box
                              key={val}
                              component="label"
                              sx={{
                                display:"flex", alignItems:"center",
                                padding:"3px 11px", borderRadius:"12px", cursor:"pointer",
                                fontSize:"11px", fontWeight:700, letterSpacing:"0.4px",
                                backgroundColor: isSelected ? (isPass ? "#27a348" : "#c0392b") : "transparent",
                                color: isSelected ? "#fff" : (isPass ? "#27a348" : "#c0392b"),
                                border: `1.5px solid ${isPass ? "#27a348" : "#c0392b"}`,
                                userSelect:"none",
                                transition:"background-color 0.12s, color 0.12s",
                              }}
                            >
                              <input
                                type="radio"
                                name={`${item.key}_${ssbData.idx}`}
                                value={val}
                                checked={isSelected}
                                onChange={() => setIspChecklist(prev => ({...prev, [item.key]: val}))}
                                style={{display:"none"}}
                              />
                              {val}
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                    {/* 사유 textarea */}
                    <Box>
                      <Box sx={{
                        fontSize:"11px", fontWeight:700,
                        color: isFail ? "#c0392b" : "#5a5a8a",
                        marginBottom:"4px", letterSpacing:"0.3px",
                        display:"flex", alignItems:"center", gap:"4px",
                      }}>
                        <Box component="span" sx={{
                          display:"inline-block", width:"3px", height:"11px",
                          borderRadius:"2px",
                          backgroundColor: isFail ? "#c0392b" : "#8080c0",
                        }}/>
                        사유
                      </Box>
                      <textarea
                        spellCheck={false}
                        value={ispReasons[item.key] || ''}
                        onChange={(e) => setIspReasons(prev => ({...prev, [item.key]: e.target.value}))}
                        placeholder="사유를 입력하세요"
                        style={{
                          width:"100%", boxSizing:"border-box", resize:"vertical",
                          fontSize:"12px", padding:"7px 9px", borderRadius:"5px",
                          border: isFail ? "1.5px solid #e8a0a0" : "1.5px solid #c8c8e8",
                          fontFamily:"inherit", lineHeight:"1.5",
                          color: isFail ? "#7a2020" : "#333",
                          outline:"none", minHeight:`${item.height}px`,
                          backgroundColor: isFail ? "#fff6f6" : "#f6f6fb",
                        }}
                      />
                    </Box>
                  </Box>
                );
              })}
            </Box>
          </Box>

          {/* 저장 버튼 */}
          <Box sx={{marginTop:"20px", display:"flex", flexDirection:"column", gap:"8px"}}>
            <Button
              variant="contained" fullWidth
              disabled={!ssbData.idx || hasIspFailItem}
              sx={{height:"44px", fontSize:"14px", fontWeight:700, borderRadius:"8px", letterSpacing:"2px",
                backgroundColor: hasIspFailItem ? "#aaa" : "#3e36a5",
                boxShadow: hasIspFailItem ? "none" : "0 2px 6px rgba(62,54,165,0.35)",
                "&:hover":{backgroundColor: hasIspFailItem ? "#aaa" : "#2d2880"},
                cursor: hasIspFailItem ? "not-allowed" : "pointer",
              }}
              onClick={() => handleSave('Y')}
            >
              <Box sx={{display:"flex", flexDirection:"column", alignItems:"center", gap:"2px"}}>
                <Box>적합</Box>
                {hasIspFailItem && (
                  <Box sx={{fontSize:"10px", fontWeight:600, letterSpacing:"0px", color:"#ff6b6b"}}>
                    FAIL 항목이 있어 클릭할 수 없습니다
                  </Box>
                )}
              </Box>
            </Button>
            <Button
              variant="contained" fullWidth
              disabled={!ssbData.idx}
              sx={{height:"44px", fontSize:"14px", fontWeight:700, backgroundColor:"#c0392b", borderRadius:"8px",
                boxShadow:"0 2px 6px rgba(192,57,43,0.35)",
                "&:hover":{backgroundColor:"#a93226"}, letterSpacing:"2px"}}
              onClick={() => handleSave('N')}
            >
              부적합
            </Button>
            <Box sx={{marginTop:"4px"}}>
              <Box sx={{fontSize:"11px", color:"#888", marginBottom:"4px", fontWeight:600, letterSpacing:"0.5px"}}>작업 비고</Box>
              <textarea
                value={ssbData.job_reason || ''}
                onChange={(e) => setSsbData((prev:any) => ({ ...prev, job_reason: e.target.value }))}
                rows={1}
                placeholder="비고를 입력하세요"
                style={{
                  width:"100%", boxSizing:"border-box", resize:"vertical",
                  fontSize:"12px", padding:"8px", borderRadius:"6px",
                  border:"1px solid #ddd", fontFamily:"inherit", lineHeight:"1.5",
                  color:"#333", outline:"none",
                }}
              />
            </Box>
          </Box>
        </Box>

        {/* 작업 리스트 + 버튼 */}
        <Box sx={{marginLeft:"4px", alignSelf:"flex-start", position:"sticky", top:0, display:"flex", flexDirection:"column", marginTop:"12px"}}>

          {/* 필터 row */}
          <Box sx={{
            display:"flex", alignItems:"center", gap:"6px",
            marginBottom:"6px", width:"242px",
            backgroundColor:"#f4f4ff",
            border:"1.5px solid #9090c8", borderRadius:"8px",
            padding:"6px 10px",
            boxShadow:"0 1px 4px rgba(62,54,165,0.08)",
          }}>
            <Box sx={{fontSize:"10px", fontWeight:700, color:"#3e36a5", flexShrink:0, letterSpacing:"0.3px"}}>트랙</Box>
            <Select
              size="small" value={track_filter}
              onChange={(e) => { setTrack_filter(e.target.value); setPage(1); }}
              sx={{
                flex:1, height:"22px", fontSize:"11px", fontWeight:600,
                backgroundColor:"#fff",
                "& .MuiSelect-select":{padding:"0 20px 0 6px"},
                "& .MuiOutlinedInput-notchedOutline":{borderColor:"#9090c8"},
              }}
            >
              {['모두','T1','T2','T4'].map(v => <MenuItem key={v} value={v} sx={{fontSize:"11px"}}>{v}</MenuItem>)}
            </Select>
            <Box sx={{width:"1px", height:"16px", backgroundColor:"#c8c8e0", flexShrink:0}} />
            <Box sx={{fontSize:"10px", fontWeight:700, color:"#3e36a5", flexShrink:0, letterSpacing:"0.3px"}}>상태</Box>
            <Select
              size="small" value={job_yn_filter}
              onChange={(e) => { setJob_yn_filter(e.target.value); setPage(1); }}
              sx={{
                flex:1.4, height:"22px", fontSize:"11px", fontWeight:600,
                backgroundColor:"#fff",
                "& .MuiSelect-select":{padding:"0 20px 0 6px"},
                "& .MuiOutlinedInput-notchedOutline":{borderColor:"#9090c8"},
              }}
            >
              <MenuItem value="모두" sx={{fontSize:"11px"}}>모두</MenuItem>
              <MenuItem value="미작업" sx={{fontSize:"11px"}}>미작업</MenuItem>
              <MenuItem value="Y" sx={{fontSize:"11px"}}>적합</MenuItem>
              <MenuItem value="N" sx={{fontSize:"11px"}}>부적합</MenuItem>
            </Select>
          </Box>

          <Box sx={{
            width:"242px",
            border:"1.5px solid #9090c8", borderRadius:"8px", overflow:"hidden",
            boxShadow:"0 2px 8px rgba(0,0,0,0.08)",
            maxHeight:"920px", display:"flex", flexDirection:"column",
          }}>
            {/* 헤더 */}
            <Box sx={{
              display:"flex", alignItems:"center", gap:"6px",
              padding:"7px 12px", backgroundColor:"#000",
            }}>
              <img style={{width:"16px", objectFit:"cover", borderRadius:"2px"}} src={process.env.PUBLIC_URL + '/img/ko_flag.jpg'} />
              <Box sx={{color:"#fff", fontSize:"12px", fontWeight:700, letterSpacing:"0.5px"}}>작업 목록</Box>
              {total_cnt > 0 && (
                <Box sx={{
                  marginLeft:"auto", backgroundColor:"rgba(255,255,255,0.2)",
                  color:"#fff", fontSize:"12px", fontWeight:700,
                  padding:"1px 6px", borderRadius:"20px",
                }}>
                  {total_cnt} 건
                </Box>
              )}
            </Box>

            {/* 리스트 */}
            <Box sx={{flex:1, overflowY:"auto", backgroundColor:"#fff"}}>
              {(ssbWorkList != undefined && ssbWorkList.length > 0)
                ? ssbWorkList.map((row:any, index:number) => {
                    const isSelected = ssbData != undefined && row.bmk_id === ssbData.bmk_id;
                    const statusColor =
                      row.job_yn === "Y" ? "#27a348" :
                      row.job_yn === "P" ? "#7427cc" :
                      row.job_yn === "N" ? "#c0392b" : "#bbb";
                    const statusBg =
                      row.job_yn === "Y" ? "#f0fff4" :
                      row.job_yn === "P" ? "#f5eeff" :
                      row.job_yn === "N" ? "#fff0ee" : "#f5f5f5";
                    const statusLabel =
                      row.job_yn === "Y" ? "완료" :
                      row.job_yn === "P" ? "반려" :
                      row.job_yn === "N" ? "부적합" : "미작업";
                    return (
                      <Box
                        key={index}
                        onClick={() => {
                        setSsbData(!row.job_yn || row.job_yn === '' ? { ...row, job_reason: '' } : row);
                        setIspChecklist(initIspChecklist);
                        setIspReasons(initIspReasons);
                        try { setOptions(row.options ? JSON.parse(row.options) : []); } catch { setOptions([]); }
                      }}
                        sx={{
                          display:"flex", alignItems:"center", justifyContent:"space-between",
                          padding:"5px 10px 5px 0",
                          cursor:"pointer",
                          borderLeft: isSelected ? "4px solid #3e36a5" : "4px solid transparent",
                          backgroundColor: isSelected ? "#eeeeff" : "transparent",
                          borderBottom:"1px solid #f0f0f4",
                          "&:hover": { backgroundColor: isSelected ? "#eeeeff" : "#f5f5ff" },
                        }}
                      >
                        <Box sx={{
                          display:"flex", alignItems:"center", gap:"2px",
                          fontSize:"11px", fontWeight: isSelected ? 600 : 400,
                          color: isSelected ? "#3e36a5" : "#555",
                          minWidth:"60px",
                        }}>
                          {index+1}. {row.bmk_id}
                        </Box>
                        <Box sx={{display:"flex", alignItems:"center", gap:"4px"}}>
                          <Box sx={{
                            fontSize:"8px", fontWeight:600,
                            padding:"1px 5px", borderRadius:"20px",
                            border:`1.5px solid ${statusColor}`,
                            color: statusColor,
                            backgroundColor: statusBg,
                          }}>
                            {statusLabel}
                          </Box>
                          {(() => {
                            const cl = row.prc_checklist || '';
                            const failNums: number[] = [];
                            for (let i = 0; i < cl.length; i++) {
                              if (cl[i] === 'F') failNums.push(i + 1);
                            }
                            if (failNums.length === 0) return null;
                            const display = failNums.slice(0, 3);
                            const hasMore = failNums.length > 3;
                            return (
                              <Box sx={{fontSize:"10px", fontWeight:700, color:"#c0392b", flexShrink:0, lineHeight:1}}>
                                {display.join(',')}
                                {hasMore && '+'}
                              </Box>
                            );
                          })()}
                          {row.job_reason && (
                            <Box sx={{
                              width:"6px", height:"6px", borderRadius:"50%",
                              backgroundColor:"#f5c518", flexShrink:0,
                            }} />
                          )}
                        </Box>
                      </Box>
                    );
                  })
                : <Box sx={{padding:"20px", textAlign:"center", fontSize:"12px", color:"#bbb"}}>데이터 없음</Box>
              }
            </Box>

            {/* 페이지네이션 */}
            {pagination !== undefined && (
              <Box sx={{borderTop:"1px solid #e8e8f0", padding:"4px", backgroundColor:"#fafafa"}}>
                <CustomPagination pagination={pagination} goPage={goPage} />
                <Box sx={{display:"flex", alignItems:"center", marginTop:"6px", gap:"4px"}}>
                  <TextField
                    size="small" id="worker" value={c_page}
                    onChange={(e) => setC_page(e.target.value)}
                    sx={{width:"80px"}}
                    InputProps={{
                      style: {height:"26px", fontSize:"12px"},
                      inputProps: {spellCheck:"false"},
                    }}
                  />
                  <Button
                    variant="contained" size="small"
                    sx={{minWidth:"40px", height:"26px", fontSize:"11px", fontWeight:700, backgroundColor:"#3e36a5", padding:"0 8px"}}
                    onClick={() => setPage(Number(c_page))}
                  >
                    이동
                  </Button>
                </Box>
              </Box>
            )}

          </Box>

        </Box>
      {/* 작업 리스트 */}
            
      </Box>

    </Paper>
  );
  
  
};

export default IspWorkerPage;
